// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./Breakpoints/breakpoint.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./Colors/color.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./ZIndex/z-index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./Font/font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./Space/space.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./Components/button.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./Components/input.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
	width: 100vw; height: 100vh;
	margin: 0; padding: 0;

	background-color: var(--color-layout-0);
	color: var(--color-layout-F);
}

*, *:before, *:after {
	box-sizing: border-box;
}

/* SCROLLBAR */
::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}
::-webkit-scrollbar-button {
	width: 0px;
	height: 0px;
}
::-webkit-scrollbar-thumb {
	background: var(--color-layout-E);
	border: 0px none var(--color-layout-F);
	border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
	background: var(--color-layout-F);
}
::-webkit-scrollbar-thumb:active {
	background: var(--color-layout-F);
}
::-webkit-scrollbar-track {
	background: var(--color-layout-6);
	border: 0px none var(--color-layout-F);
	border-radius: 46px;
}
::-webkit-scrollbar-track:hover {
	background: var(--color-layout-6);
}
::-webkit-scrollbar-track:active {
	background: var(--color-layout-6);
}
::-webkit-scrollbar-corner {
	background: transparent;
}

/* CANVAS TESTING */
.canvas-auto-test {
	max-width: 0;
	max-height: 0;
}

img {
	max-width:100%;
}

.icon {
	margin: 4px 12px 0 6px;
    min-width: 14px;
    min-height: 14px;
    width: 16px;
    height: 16px;
    width: 1.5vmax;
    height: 1.3vmax;
}

#root > .data-display.ERROR > .dd-it-icon,
#root > .data-display.ERROR_RETRY > .dd-it-icon,
#root > .data-display.ERROR_LOGOUT > .dd-it-icon,
#root > .data-display.ERROR_UNKNOWN > .dd-it-icon,
#root > .data-display.EMPTY > .dd-it-icon {
	width: 36px; height: 36px;
	width: var(--font-10); height: var(--font-10);
}

#adalIdTokenFrame {top: 0;}`, "",{"version":3,"sources":["webpack://./src/Theme/index.css"],"names":[],"mappings":"AAQA;CACC,YAAY,EAAE,aAAa;CAC3B,SAAS,EAAE,UAAU;;CAErB,uCAAuC;CACvC,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;AACvB;;AAEA,cAAc;AACd;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,iCAAiC;CACjC,sCAAsC;CACtC,mBAAmB;AACpB;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;CACjC,sCAAsC;CACtC,mBAAmB;AACpB;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,uBAAuB;AACxB;;AAEA,mBAAmB;AACnB;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;;;;;CAKC,WAAW,EAAE,YAAY;CACzB,qBAAqB,EAAE,sBAAsB;AAC9C;;AAEA,mBAAmB,MAAM,CAAC","sourcesContent":["@import './Breakpoints/breakpoint.css';\r\n@import './Colors/color.css';\r\n@import './ZIndex/z-index.css';\r\n@import './Font/font.css';\r\n@import './Space/space.css';\r\n@import './Components/button.css';\r\n@import './Components/input.css';\r\n\r\nhtml, body, #root {\r\n\twidth: 100vw; height: 100vh;\r\n\tmargin: 0; padding: 0;\r\n\r\n\tbackground-color: var(--color-layout-0);\r\n\tcolor: var(--color-layout-F);\r\n}\r\n\r\n*, *:before, *:after {\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n/* SCROLLBAR */\r\n::-webkit-scrollbar {\r\n\twidth: 8px;\r\n\theight: 8px;\r\n}\r\n::-webkit-scrollbar-button {\r\n\twidth: 0px;\r\n\theight: 0px;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n\tbackground: var(--color-layout-E);\r\n\tborder: 0px none var(--color-layout-F);\r\n\tborder-radius: 50px;\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n\tbackground: var(--color-layout-F);\r\n}\r\n::-webkit-scrollbar-thumb:active {\r\n\tbackground: var(--color-layout-F);\r\n}\r\n::-webkit-scrollbar-track {\r\n\tbackground: var(--color-layout-6);\r\n\tborder: 0px none var(--color-layout-F);\r\n\tborder-radius: 46px;\r\n}\r\n::-webkit-scrollbar-track:hover {\r\n\tbackground: var(--color-layout-6);\r\n}\r\n::-webkit-scrollbar-track:active {\r\n\tbackground: var(--color-layout-6);\r\n}\r\n::-webkit-scrollbar-corner {\r\n\tbackground: transparent;\r\n}\r\n\r\n/* CANVAS TESTING */\r\n.canvas-auto-test {\r\n\tmax-width: 0;\r\n\tmax-height: 0;\r\n}\r\n\r\nimg {\r\n\tmax-width:100%;\r\n}\r\n\r\n.icon {\r\n\tmargin: 4px 12px 0 6px;\r\n    min-width: 14px;\r\n    min-height: 14px;\r\n    width: 16px;\r\n    height: 16px;\r\n    width: 1.5vmax;\r\n    height: 1.3vmax;\r\n}\r\n\r\n#root > .data-display.ERROR > .dd-it-icon,\r\n#root > .data-display.ERROR_RETRY > .dd-it-icon,\r\n#root > .data-display.ERROR_LOGOUT > .dd-it-icon,\r\n#root > .data-display.ERROR_UNKNOWN > .dd-it-icon,\r\n#root > .data-display.EMPTY > .dd-it-icon {\r\n\twidth: 36px; height: 36px;\r\n\twidth: var(--font-10); height: var(--font-10);\r\n}\r\n\r\n#adalIdTokenFrame {top: 0;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
